import styled from 'styled-components';

export const CommonBlogCarouselStyled = styled.div`
  
  .slick-slider {
    margin: 0 0 20px 0;

    .slick-list {
      width: 100%;
      margin: 0;
      .slick-list img {
      border-radius:none !important;
      }
    }
  }

  .dealItemBox {
    width: 100%;

    .item {
      width: 100%;
      margin: 0 7px 0 0px;
      padding: 16px;
      background: ${(props) => props.theme.color.white};
      border: 1px solid ${(props) => props.theme.color.lightGray};
      border-radius: 8px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      a {
        width: 100%;
      }

      .name {
        width: 100%;
        height: 65px;
        margin: 0 0 8px 0;
        font-size: 15px;
        font-weight: 600;
        overflow: hidden;
        cursor: pointer;
      }
      
      .delivery {
        height: 39px;
        color: ${(props) => props.theme.text.medium};
        font-size: 12px;
        text-align: left;
        padding: 3px 0 0 22px;
        margin: 0 0 8px 0;
        overflow: hidden;
        span {
          font-weight: 700;
        }
      }
    }
  }

  @media (max-width: 820px) {
    padding: 0 0 5px 0;

    .container {
      padding: 16px 0;
    }

    .slick-slider {
      margin: 0;
    }
  }

  @media (max-width: 480px) {
    .slick-slide {
      width: 45.5vw !important;
    }
    .sectionBox {
      padding-bottom: 0;
      padding-left: 0;
      padding-right: 0;

      .container {
        .titleBar {
          padding-left: 16px;
          padding-right: 16px;
        }

        .slick-arrow {
          &.slick-prev {
            left: 0;
          }
          &.slick-next {
            right: 0;
          }
        }
      }
    }
    .container {
      .pageContent {
        .titleBar {
          .title {
            font-size: 18px;
            margin: 16px;
          }
        }
      }
    }

    .dealItemBox {
      max-width: 100%;
      margin: 0;

      .item {
        padding: 10px;
        border-radius: 0;
        border-left: 0;
        border-top: 0;

        .name {
          height: 50px;
          font-size: 14px;
          line-height: 17px;
          margin-bottom: 2px;
        }

        .delivery {
          height: 30px;
          background-position: 0 6px;
          font-size: 11px;
          line-height: 14px;
          margin-bottom: 4px;
        }
      }
    }

    .dealItemBox {
      max-width: 100%;
      margin: 0;

      .item {
        padding: 10px;
   
        .name {
          height: 50px;
          font-size: 14px;
          line-height: 17px;
          margin-bottom: 2px;
        }
        
        .delivery {
          height: 30px;
          background-position: 0 6px;
          font-size: 11px;
          line-height: 14px;
          margin-bottom: 4px;
        } 
      }
    }
  }
  @media (max-width: 380px) {
    .slick-slide {
      width: 65vw !important;
    }
  }
`;